import React, { createContext, useContext, useState, ReactNode } from "react";

interface ModalContextType {
  openModals: Set<string>;
  registerModal: (id: string) => void;
  unregisterModal: (id: string) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [openModals] = useState(() => new Set<string>());

  const registerModal = (id: string) => {
    openModals.add(id);
  };

  const unregisterModal = (id: string) => {
    openModals.delete(id);
  };

  return (
    <ModalContext.Provider value={{ openModals, registerModal, unregisterModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within ModalProvider");
  }
  return context;
};
